import { HiddenDesktop } from '../../layouts/LayoutWithLeftDesktopNav/Reusable/HiddenDesktop/HiddenDesktop';
import { NavigationBackButton } from '../../navigation';
import { HiddenMobile } from '../../layouts/LayoutWithLeftDesktopNav/Reusable/HiddenMobile/HiddenMobile';
import { css } from '@bts-web/utils-style-engine';
import { ReactNode } from 'react';
import { NavigationBar } from '../../common/components/NavigationBar/NavigationBar';
import { CloseDrawerButton } from '../../common/components/Drawer/CloseDrawerButton';

export interface TransactionDetailsLayoutProps {
  navigationBarTitle?: string;
  children: ReactNode;
  backButtonComponent?: ReactNode;
  withClose?: boolean;
}

export const TransactionDetailsLayout = ({
  children,
  navigationBarTitle,
  backButtonComponent = <NavigationBackButton />,
  withClose = false,
}: TransactionDetailsLayoutProps) => {
  return (
    <div
      data-testid="transaction-details-layout"
      className={css({
        display: 'flex',
        flexDirection: 'column',
        flex: 'auto',
        gap: 'medium',
        minHeight: '100%',
      })}
    >
      {navigationBarTitle && (
        <div
          className={css({
            display: 'flex',
            justifyContent: 'space-between',
            position: 'sticky',
            top: 0,
            width: '100%',
            '& nav': {
              width: '100%',
            },
          })}
        >
          <NavigationBar
            title={navigationBarTitle}
            NavigationLeftSlot={
              <HiddenDesktop>{backButtonComponent}</HiddenDesktop>
            }
            {...(withClose
              ? {
                  NavigationRightSlot: (
                    <HiddenMobile>
                      <CloseDrawerButton />
                    </HiddenMobile>
                  ),
                }
              : {})}
          />
        </div>
      )}

      <div
        className={css({
          width: '100%',
          gap: 'extra_small_2',
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        })}
      >
        {children}
      </div>
    </div>
  );
};
